import { BenefitType } from '@/types/benefits/benefitTypes';
import {
  getBenefitTypeName,
  getBenefitTypeTranslatedLabel,
} from '@/utils/benefits/getBenefitTypeName';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

const BenefitTypeCell = ({ type }: { type: string }) => {
  const { t } = useTranslation();
  const colorMap = {
    [BenefitType.ACTIVITY]: 'border-pink-200 bg-pink-50 text-pink-700',
    [BenefitType.HOTEL]: 'border-warning-200 bg-warning-50 text-warning-700',
    [BenefitType.VOL]: 'border-sky-200 bg-sky-50 text-sky-700',
    [BenefitType.VEHICLE]: 'border-purple-200 bg-purple-50 text-purple-700',
    [BenefitType.VEHICLE_WITH_CHAUFFEUR]:
      'border-purple-200 bg-purple-50 text-purple-700',
    [BenefitType.MEAL]: 'border-pink-200 bg-pink-50 text-pink-700',
    [BenefitType.TRANSFER]: 'border-pink-200 bg-pink-50 text-pink-700',
  };

  const benefitType = useMemo(() => getBenefitTypeName(type), [type]);
  const cellLabel = useMemo(
    () => getBenefitTypeTranslatedLabel(t, benefitType),
    [benefitType, t],
  );

  return (
    <span
      className={`px-2 py-0.5 border rounded-lg text-sm font-medium ${colorMap[benefitType]}`}
    >
      {cellLabel}
    </span>
  );
};

export default BenefitTypeCell;
